import { gql } from "@apollo/client";
import { LoadingIndicator } from "@resource/atlas";
import { AtssyncAccountType, V2IntegrationsPage } from "generated/schemaTypes";
import useQuery from "utils/useQuery";

import { AtsIntegrationCard } from "./__components/AtsIntegrationCard";
import { CUSTOMER_FOR_INTEGRATIONS_PAGE_FRAGMENT } from "./__fragments/customer";

const V2_INTEGRATIONS_PAGE = gql`
  query V2IntegrationsPage {
    currentOrganization {
      id
      customer {
        ...CustomerForIntegrationsPage
      }
    }
  }

  ${CUSTOMER_FOR_INTEGRATIONS_PAGE_FRAGMENT}
`;

export function V2IntegrationsPage() {
  const { data } = useQuery<V2IntegrationsPage>(V2_INTEGRATIONS_PAGE);

  if (!data?.currentOrganization?.customer?.atssyncAccounts) {
    return (
      <div className="flex h-full justify-center items-center">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className="flex flex-row flex-wrap gap-6">
      <AtsIntegrationCard
        atsType={AtssyncAccountType.GREENHOUSE}
        customer={data.currentOrganization.customer}
      />
      <AtsIntegrationCard
        atsType={AtssyncAccountType.ASHBY}
        customer={data.currentOrganization.customer}
      />
      <AtsIntegrationCard
        atsType={AtssyncAccountType.LEVER}
        customer={data.currentOrganization.customer}
      />
    </div>
  );
}
